import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// helpers
import { truncate } from '../../helpers';
//styles
import './blog.scss';

const CardBlogCategory = ({ post, assignedLibrary }) => {
  const { t } = useTranslation(['blog', 'backoffice']);

  return (
    <Card className="card-blog-card h-100 position-relative">
      <div
        className={`card-blog-image ${post.isFirstPost ? 'first-post' : ''}`}
        style={{ backgroundImage: `url(${post.featured_image})` }}
      ></div>
      {post.category?.image && (
        <img
          src={post.category.image}
          alt="Category"
          className="category-icon"
        />
      )}
      <Link
        to={`/${assignedLibrary}/blog/${post.publish_date}/${post.slug}`}
        className="text-decoration-none">
        <Card.Title className="card-blog-title-category px-3 pt-3 m-0">{truncate(post.title)}</Card.Title>
      </Link>
      <Card.Body>
        <div className="d-flex flex-column flex-sm-row align-items-center gap-2">
          <div className="card-blog-date text-center text-sm-start">
            {new Date(post.publish_date).toISOString().split('T')[0].replace(/-/g, '/')}
          </div>
          <div className="card-blog-category d-flex justify-content-center justify-content-sm-start">
            <div className="card-blog-category-name">
              {t('in')}
              <span className="card-blog-category-link px-2">
                {post.category?.name}
              </span>
            </div>
          </div>
        </div>
        <div className="card-blog-footer d-flex flex-column">
          {truncate(post.featured_paragraph, post.isFirstPost ? 230 : 45)}
          <div className="mt-2">
            <Link
              to={`/${assignedLibrary}/blog/${post.publish_date}/${post.slug}`}
              className="blog-watchmore">
              {post.isFirstPost ? t('goPost', { ns: 'blog' }) : t('seeMore', { ns: 'backoffice' })}
            </Link>
          </div>
        </div>
      </Card.Body>
    </Card >
  );
};

CardBlogCategory.propTypes = {
  post: PropTypes.object.isRequired,
  assignedLibrary: PropTypes.string.isRequired,
};

export default CardBlogCategory;